module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAABMklEQVR42o2SO0rHQBDGo7UgWgo+TyB4Dk8giJY7iTs7szEJYpFCtLHTwlIbWz2BFxCvoPjAQhEL7Sw0X/hHJdliB34wzM5880iSkBHrUcMnWXk0rE/Gyrdz1UISayhIvZ8n1dkW1nNifxhOlmoJBYblmVgfRnz8+sDKS8Mr/H+cjMaVd+NU0Ym5nIulnZJlF/t+he8g1+hkWN+M9SuDd+uLdi0ohQS6w5HVPdB/T9nvpFb3+wLofGNY7hFvbIwkX4UPMElQINS5LMvJLoadu0miBBo2yW0v/02l68bqcZyA81vGySnidV2PE0sGn1gvTFVNhQUC1hY53eh3Dgpg52GCWmI9IyuXIjI9/Ix6RSwHCTm/BpEmcGtY7mJAPqC6nkhgWVHMYIoszxdjwO+P+6D2B7j0CZaLg5g3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/c-health_1x.png
// module id = 2285
// module chunks = 0